import { Provider } from '../PreCheckedProviders.types'

/**
 * GetLabsAndImagingText determines the type of services provided based on the
 * category name of the providers.
 *
 * @param providers - An array of provider objects
 * @returns A string that represents the type of services
 */
export const getLabsAndImagingText = (providers: Provider[]): string => {
  let otherServicesText = 'labs and imaging'
  // assuming all providers have the same category name, compare against the first provider
  if (
    providers?.length > 0 &&
    providers[0]?.categoryName === 'Diagnostic Imaging'
  ) {
    otherServicesText = 'labs'
  }
  if (providers?.length > 0 && providers[0]?.categoryName === 'Labs') {
    otherServicesText = 'imaging'
  }

  return otherServicesText
}
